import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { act } from 'react';
import { toast } from "react-toastify";


export const takeSeoProtected = createAsyncThunk(
  'seo/taekeSeoLogged-protected',
  async ({ data, token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/seo/pass-protected-website`,
        data,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.status) {
        return response.data;
      } else {
        return rejectWithValue("Failed to shorten URL");
      }
    } catch (error) {
      return rejectWithValue(error.message || "Network error");
    }
  }
);


export const SeoMoveInFolder = createAsyncThunk(
  "scraper/moveInFolder",
  async ({ token, folderId, id }, { rejectWithValue }) => {


      try {

          const response = await axios.patch(
              `${process.env.REACT_APP_BASE_URL}/seo/folders/move-in-folder`,
              {},
              {
                  headers: {
                      Authorization: `Bearer ${token}`,
                  },
                  params: {
                      seoId: id, folderId
                  }
              }
          );

          if (response.data.status) {
              // console.log(response.data.response);
              return {id,folderId,response:response.data.response};
          } else {
              return rejectWithValue("Failed to Add in folder");
          }
      } catch (error) {

          return rejectWithValue(
              error.response?.data || "Error to add in folder "
          );
      }
  }
);

export const deleteSeo = createAsyncThunk(
  "seo/deleteSeo",
  async ({ key, token }, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_BASE_URL}/seo/scraper/${key}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200 || response.statusCode === 200) {
        return {key,response:response.data.response};
      } else {
        return rejectWithValue(response.data?.message || "Failed to delete link");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || "Network error"
      );
    }
  }
);


export const loggedTakeSeo = createAsyncThunk(
  'seo/taekeSeoLogged',
  async ({ data, token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/seo/scraper/try`,
        data,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.status) {
        return response.data;
      } else {
        return rejectWithValue("Failed to shorten URL");
      }
    } catch (error) {
      return rejectWithValue(error.message || "Network error");
    }
  }
);


export const fetchSeoData = createAsyncThunk(
  'seo/fetchSeoData',
  async ({ token, offset = 1, limit = 10,onlyMy }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/seo/scraper/list`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            offset,
            limit,
            onlyMy,
          },
        }
      );

      if (response.data.status) {
        return { offset, response: response.data.response };
      }
      return rejectWithValue("Failed to fetch SEO data");
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch SEO data');
    }
  }
);

const seoSlice = createSlice({
  name: 'seo',
  initialState: {
    data: [],
    isLoading: false,
    error: null,
  },
  reducers: {
    addDummySeo: (state, action) => {
      state.data.unshift(action.payload);
    },
    removeDummySeo: (state, action) => {
      state.data.shift();
    },
    clearSeo: (state) => {
      state.data = [];
    },
     removeFromFolderSeo: (state, action) => {
          const seo = state.data.find(seo => seo.seoId === action.payload.key);
          if (seo) {
            seo.folderId = null;
          }
        },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSeoData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchSeoData.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.offset === 1) {
          state.data = action.payload.response;
        } else {
          state.data = [...state.data, ...action.payload.response];
        }
      })
      .addCase(fetchSeoData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(deleteSeo.fulfilled, (state, action) => {
        state.data = state.data.filter(item => item.seoId !== action.payload.key);
        toast(action.payload.response)
      })
      .addCase(deleteSeo.rejected, (state, action) => {
        state.error = action.payload;
        toast(action.payload)

      })
      .addCase(loggedTakeSeo.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(loggedTakeSeo.fulfilled, (state, action) => {
        state.isLoading = false;
        toast.success("Fetched SEO details successfully")
       
      })
      .addCase(loggedTakeSeo.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        toast.error(action.payload)

      })
      .addCase(SeoMoveInFolder.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(SeoMoveInFolder.fulfilled, (state, action) => {  
        state.isLoading = false;
        const { id, folderId, response } = action.payload;
        const seoItem = state.data.find(item => item.seoId === id);
        if (seoItem) {
          seoItem.folderId = folderId;
          seoItem.folderName = response;
        }
        toast.success(action.payload.response)
      })
      .addCase(SeoMoveInFolder.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        toast.error(action.payload)
      })

  },
});

export const { addDummySeo, removeDummySeo, clearSeo,removeFromFolderSeo } = seoSlice.actions;
export default seoSlice.reducer;
